(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('ConversationService', ConversationService);

  ConversationService.$inject = ['$resource'];

  function ConversationService ($resource) {
    return $resource(apiUrl + '/automation/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      loadSectorMetadata: { url: apiUrl + '/contact-metadata-definition/:company_id/:sector_id', isArray: true },
      loadContactMetadata: { url: apiUrl + '/contact-metadata/:sector_id/:user_id', isArray: true },
      saveContactMetadata: { method: 'POST', url: apiUrl + '/contact-metadata', isArray: true },
      sendMessage: { url: baseUrl + '/send-message/:user_id', method: 'POST', params: {}, isArray: false },
      sendAttachment: { url: baseUrl + '/send-attachment/:user_id', method: 'POST', params: {}, isArray: false },
      sendHsm: { url: baseUrl + '/send-hsm/:user_id', method: 'POST', params: {}, isArray: false },
      setStatus: { url: apiUrl + '/set-status/:company_id/:sector_id/:user_id', method: 'POST', params: {}, isArray: false },
      saveNotes: { url: apiUrl + '/save-notes/:user_id', method: 'POST', params: {}, isArray: false },
      setAnswered: { url: apiUrl + '/set-answered/:sector_id/:user_id', method: 'POST', params: {}, isArray: false },
      setSector: { url: apiUrl + '/switch-sector/:user_id', method: 'POST', params: {}, isArray: false },
      setOperator: { url: apiUrl + '/switch-operator/:user_id', method: 'POST', params: {}, isArray: false },
      removeClassification: { url: apiUrl + '/remove-classification/:company_id/:sector_id/:user_id', method: 'POST', params: {}, isArray: false },
      getMetadataDefinition: { url: apiUrl + '/get-metadata-definition', method: 'GET', params: {}, isArray: true },
      saveNoClassification: { url: apiUrl + '/save-no-classification', method: 'POST', params: {}, isArray: false },
      resendEmailAcionaSeguro: { url: apiUrl + '/resend-email-aciona-seguro', method: 'POST', params: {}, isArray: false },
      delLockedContact: { url: apiUrl + '/del-locked-contact', method: 'POST', params: {}, isArray: false },
      filterUsers: { url: apiUrl + '/filter-users', method: 'POST', params: {}, isArray: false },
      sendLinkTelesaqueB2b: { url: baseUrl + '/send-message/:user_id/telesaque-b2b', method: 'POST', params: {}, isArray: false },
      getProtocolNumber: { url: apiUrl + '/get-protocol-number', method: 'POST', params: {}, isArray: false }
    });
  }
})();
